// extracted by mini-css-extract-plugin
export default {"skeleton__head":"styles_skeleton__head__HY42e","skeleton__column":"styles_skeleton__column__vc3SC","table__skeleton":"styles_table__skeleton__q-KNv"};